'use strict';

var _registerCSSInterfaceWithDefaultTheme = require('./utils/registerCSSInterfaceWithDefaultTheme');

var _registerCSSInterfaceWithDefaultTheme2 = _interopRequireDefault(_registerCSSInterfaceWithDefaultTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _registerCSSInterfaceWithDefaultTheme2['default'])();


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-dates/lib/initialize.js
// module id = 4173
// module chunks = 168707334958949